module.exports = __webpack_public_path__ + "static/media/unit4.ace82dbc.svg";